import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { SettingsItemDescription, SettingsItemTitle, SettingsSection, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import { selectPotProductFromProductId } from '../reducers/selectors';
const AccumulatedInterestSection = ({ pot }) => {
    const potProduct = useAppSelector((store) => selectPotProductFromProductId(store, pot.productId));
    const { accruedInterest } = pot;
    // Product names are singular nouns ending in "Pot" ("Easy Access Pot").
    const pluralisedProductName = potProduct?.name ? `${potProduct.name}s` : 'pots';
    return (<SettingsSection noMarginTop pointerEvents="none" withPadding>
      <View style={styles.row}>
        <View style={styles.flex}>
          <SettingsItemTitle>{accruedInterest ? 'Accrued' : 'Earned'} interest</SettingsItemTitle>
        </View>
        {!!accruedInterest && <Amount Numbers-16 value={accruedInterest}/>}
      </View>
      <Spacer h={4}/>
      <SettingsItemDescription>
        {`${accruedInterest ? 'This is the money you have so far earned' : 'This is the money you are earning'} across all your ${pluralisedProductName}. This is paid ${potProduct?.interestPaymentFrequency?.toLocaleLowerCase() || 'daily'}${potProduct?.interestPaymentFrequency === 'DAILY' ? ', Tuesday to Saturday' : ''}.\n\nThis balance is part of the same account and the interest is compounding.`}
      </SettingsItemDescription>
    </SettingsSection>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
});
export default memo(AccumulatedInterestSection);
